import React, { useState } from "react";
import "./Custompc.css";

export default function Custompc() {
  const [step, setStep] = useState(1);

  const cabinetData = [
    { id: 1, name: "Cooler Master MB511", price: 4500, image: "https://m.media-amazon.com/images/I/51bThssmgTL._SY300_SX300_QL70_FMwebp_.jpg" },
    { id: 2, name: "Ant Esports ICE-200TG", price: 3800, image: "https://www.coconutlife.in/cdn/shop/files/CosmicBlack_2.jpg?v=1709028225&width=2376" },
    { id: 3, name: "Lian Li Lancool C", price: 5200, image: "https://www.coconutlife.in/cdn/shop/files/SolarBlack_2.jpg?v=1701873289&width=2376" },
    { id: 4, name: "NZXT H510", price: 5600, image: "https://www.coconutlife.in/cdn/shop/files/WhatsApp_Image_2025-07-08_at_5.07.15_PM.jpg?v=1759338396&width=2376" },
  ];

  const cpus = [
    { id: 1, name: "Intel i5 12th Gen", price: 12000, image: "https://m.media-amazon.com/images/I/51saxT83YWL.jpg" },
    { id: 2, name: "Intel i7 12th Gen", price: 20000, image: "https://m.media-amazon.com/images/I/519MVS4lEuL._AC_UF1000,1000_QL80_.jpg" },
  ];

  const ramOptions = [
    { id: 1, name: "8GB DDR4", price: 1500, image: "https://m.media-amazon.com/images/I/81twuDZd0eL.jpg" },
    { id: 2, name: "16GB DDR4", price: 2600, image: "https://static6.depositphotos.com/1135132/669/i/450/depositphotos_6695663-stock-photo-high-performance-ddr3-ecc-computer.jpg" },
  ];

  const ssdOptions = [
    { id: 1, name: "256GB SSD", price: 1800, image: "https://simmtronics.co.in/wp-content/uploads/2022/12/256GB-M.2-Sata-Solid-State-Drive-%E2%80%93-SSD-S950P-1-1.webp" },
    { id: 2, name: "512GB SSD", price: 2800, image: "https://simmtronics.co.in/wp-content/uploads/2022/12/512GB-M.2-Sata-Solid-State-Drive-%E2%80%93-SSD-S950P-2-1.webp" },
    { id: 3, name: "1TB SSD", price: 4200, image: "https://simmtronics.co.in/wp-content/uploads/2022/12/1024GB-NVMe-NAND-SSD-1-1.webp" },
  ];

  const gpuOptions = [
    { id: 1, name: "GTX 1650", price: 18000, image: "https://m.media-amazon.com/images/I/61uBESCcj8L.jpg" },
    { id: 2, name: "RTX 3060", price: 35000, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrRVKFx5JTCmRO-KI8t32OVkSSQTaTgjFNhQ&s" },
  ];

  const [selection, setSelection] = useState({ cabinet: null, cpu: null, ram: null, ssd: null, gpu: null });

  const stepsMeta = ["Cabinet", "Core", "RAM", "SSD", "Graphics", "Summary"];

  const next = () => setStep((prev) => prev + 1);
  const back = () => setStep((prev) => prev - 1);

  const totalPrice = () =>
    Object.values(selection).reduce((sum, item) => (item ? sum + item.price : sum), 0);

  const isNextDisabled = () => {
    switch (step) {
      case 1: return !selection.cabinet;
      case 2: return !selection.cpu;
      case 3: return !selection.ram;
      case 4: return !selection.ssd;
      case 5: return !selection.gpu;
      default: return false;
    }
  };

  const renderStepOptions = () => {
    let data = [];
    let keyName = "";
    switch (step) {
      case 1: data = cabinetData; keyName = "cabinet"; break;
      case 2: data = cpus; keyName = "cpu"; break;
      case 3: data = ramOptions; keyName = "ram"; break;
      case 4: data = ssdOptions; keyName = "ssd"; break;
      case 5: data = gpuOptions; keyName = "gpu"; break;
      default: return null;
    }

    return (
      <div className="grid-4">
        {data.map((item) => (
          <div key={item.id} className={`cabinet-card ${selection[keyName]?.id === item.id ? "selected" : ""}`}>
            <img src={item.image} className="cabinet-img" alt={item.name} />
            <h3>{item.name}</h3>
            <p className="price">₹{item.price}</p>
            <button className="btn" onClick={() => setSelection({ ...selection, [keyName]: item })}>
              {selection[keyName]?.id === item.id ? "Selected" : "Select"}
            </button>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="wizard-container">
  <div className="custompc-container">
      <h1 className="custompc-h1">Build Your Custom PC</h1>

      {/* Stepper */}
      <div className="wizard-steps">
  {stepsMeta.map((label, index) => {
    const isCompleted = index + 1 < step;
    const isCurrent = index + 1 === step;

    return (
      <div
        key={index}
        className={`wizard-step ${isCompleted ? "completed" : ""} ${isCurrent ? "current" : ""}`}
      >
        {label}
      </div>
    );
  })}
</div>

</div>
      {/* Step content */}
      <div className="step-content">
        {step <= 5 && renderStepOptions()}

        {step === 6 && (
          <div>
            <h2>Summary</h2>
            <div className="grid-4">
              {Object.entries(selection).map(([key, item]) => 
                item && (
                  <div key={item.id} className="cabinet-card selected">
                    <img src={item.image} className="cabinet-img" alt={item.name} />
                    <h3>{item.name}</h3>
                    <p className="price">₹{item.price}</p>
                  </div>
                )
              )}
            </div>

            <h2 className="total-price">Total: ₹{totalPrice()}</h2>

            {/* Back and Submit buttons */}
            <div className="button-row">
              <button className="btn back" onClick={back}>Back</button>
              <button className="btn next" onClick={() => alert("Order Submitted!")}>Submit</button>
            </div>
          </div>
        )}
      </div>

      {/* Navigation buttons for steps 1-5 */}
      {step <= 5 && (
        <div className="button-row">
          {step > 1 && <button className="btn back" onClick={back}>Back</button>}
          {step === 5 && <button className="btn skip" onClick={next}>Skip GPU</button>}
          <button className="btn next" onClick={next} disabled={isNextDisabled()}>Next</button>
        </div>
      )}
    </div>
  );
}
